import { Button, Drawer, Form, Space, Input } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsCalendar2Check, BsCheckSquare } from "react-icons/bs";
import { RiFilterOffLine } from "react-icons/ri";
import Moment from "react-moment";
import fetchDataTrace from "../../../services/fetchDataTrace";

import BookingPanel from "./BookingPanel";
import ConfirmPanel from "./ConfirmPanel";

const { Search } = Input;

export default function BookingsPanel({
  setVisible,
  isVisible,
  selected,
}: any) {
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();
  const [updateModal, setUpdateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [bookings, setBookings] = useState<any>([]);
  const [picked, setPicked] = useState<any>({});

  const handleFetchCustomerBooking = async () => {
    if (selected?._id === undefined) {
      return;
    }
    const uri = `bookings/customers/${selected?._id}`;
    const response = await fetchDataTrace({ uri });
    setBookings(response?.payload);
  };

  useEffect(() => {
    handleFetchCustomerBooking();
  }, [selected]);

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  return (
    <Drawer
      title={`${selected?.name} : Bookings`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by vehilcle"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex flex-row">
            <button
              onClick={() => setUpdateModal(true)}
              color="#E50000"
              className="flex ml-4 justify-center items-center border p-1 hover:bg-green-100"
            >
              <BsCalendar2Check />
              <span className="ml-1">New Booking</span>
            </button>
          </div>
        </div>
        <div className="flex pt-1 pb-2 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-32 truncate font-bold">Vehicle</div>
              <div className="w-24 truncate font-bold">Date</div>
              <div className="w-48 truncate text-center font-bold">Time</div>
              <div className="w-36 truncate font-bold">Center</div>
            </div>
            <div className="font-bold w-full">Action</div>
          </div>
        </div>
        {bookings
          ?.filter((booking: any) => booking?.vehicle?.includes(search))
          .map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-32 truncate ">{item?.vehicle}</div>
                  <div className="w-24 truncate ">
                    <Moment format="Do MMM, YYYY">{item?.date}</Moment>
                  </div>
                  <div className="w-48 truncate text-center ">
                    <Moment format="HH:mm A">
                      {item?.slottime?.starttime}
                    </Moment>
                    <span className="mx-2">-</span>
                    <Moment format="HH:mm A">{item?.slottime?.endtime}</Moment>
                  </div>
                  <div className="w-36 truncate ">{item?.site?.name}</div>
                </div>
                <div className="w-full">
                  <div className="flex">
                    {item?.is_confirmed ? (
                      <button className="flex justify-center items-center ml-1 text-green-700 border rounded-md p-2 bg-green-100 hover:bg-green-200 cursor-not-allowed">
                        <BsCheckSquare />{" "}
                        <span className="ml-1">Confirmed</span>
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          setPicked(item);
                          setConfirmModal(true);
                        }}
                        className="flex justify-center items-center text-red-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
                      >
                        <span className="">Unconfirmed </span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
      <BookingPanel
        selected={selected}
        isVisible={updateModal}
        setVisible={setUpdateModal}
        refetch={handleFetchCustomerBooking}
      />

      <ConfirmPanel
        selected={picked}
        isVisible={confirmModal}
        setVisible={setConfirmModal}
        refetch={handleFetchCustomerBooking}
      />
    </Drawer>
  );
}
